import { render, staticRenderFns } from "./AssistanceInvite.vue?vue&type=template&id=0f2d6cf7&scoped=true&lang=html&"
import script from "./AssistanceInvite.vue?vue&type=script&lang=js&"
export * from "./AssistanceInvite.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceInvite.vue?vue&type=style&index=0&id=0f2d6cf7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d6cf7",
  null
  
)

export default component.exports